import classNames from 'classnames';
import * as React from 'react';
import { RibbonLeftSvg, RibbonRightSvg, SalesLeftSvg } from './svg';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Tag = props => {
  const {
    type = 'default',
    size = 's',
    width,
    sale,
    ribbon,
    disabled,
    block,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-tag");
  if (disabled) {
    restProps.onClick = undefined;
    restProps.onMouseDown = undefined;
    restProps.onMouseUp = undefined;
  }
  return /*#__PURE__*/_jsxs("span", {
    ...restProps,
    className: classNames(baseClassName, "".concat(baseClassName, "-type-").concat(type), "".concat(baseClassName, "-size-").concat(size), {
      ['sale-style']: !!sale,
      ['ribbon-style']: !!ribbon,
      disabled: !!disabled,
      block: !!block
    }, className),
    style: style,
    children: [!!sale && /*#__PURE__*/_jsx("span", {
      className: "".concat(baseClassName, "--prefix"),
      children: /*#__PURE__*/_jsx(SalesLeftSvg, {})
    }), !!ribbon && /*#__PURE__*/_jsx("span", {
      className: "".concat(baseClassName, "--prefix"),
      children: /*#__PURE__*/_jsx(RibbonLeftSvg, {})
    }), /*#__PURE__*/_jsx("span", {
      className: "".concat(baseClassName, "--content"),
      style: {
        width
      },
      children: children
    }), !!ribbon && /*#__PURE__*/_jsx("span", {
      className: "".concat(baseClassName, "--suffix"),
      children: /*#__PURE__*/_jsx(RibbonRightSvg, {})
    })]
  });
};
export default Tag;